// https://github.com/simontonsoftware/s-libs/issues/106

/**
 * Uses a binary search to determine the lowest index at which `value` should be inserted into `array` in order to maintain its sort order.
 *
 * Contribution to minified bundle size, when it is the only function imported:
 * - Lodash: 1,359 bytes
 * - Micro-dash: 295 bytes
 */
export function sortedIndex<T>(array: Nil | readonly T[], value: T): number {
  let min = 0;
  let max = array ? array.length : 0;
  while (max > min) {
    const mid = Math.floor((max + min) / 2);
    if (compareValues(array![mid], value) < 0) {
      min = mid + 1;
    } else {
      max = mid;
    }
  }
  return min;
}

type Nil = null | undefined;

const compareValues = (x: any, y: any): any => {
  let v1 = getSortOrdinal(x);
  let v2 = getSortOrdinal(y);
  if (v1 === v2) {
    v1 = x;
    v2 = y;
  }
  if (v1 < v2) {
    return -1;
  } else if (v1 > v2) {
    return 1;
  }
  return undefined;
};

const getSortOrdinal = (value: any): number => {
  if (Number.isNaN(value)) {
    return 3;
  }
  if (value === undefined) {
    return 2;
  }
  if (value === null) {
    return 1;
  }
  return 0;
};
